<template>
  <v-btn text block  @click="getPaymentPlanReportUrl" :disabled="loading" :loading="loading" class="report-button" v-if="$vuetify.breakpoint.mdAndUp">
    <v-icon class="mr-4">
      fas fa-download
    </v-icon>
    <span class="color-new-link-blue--text">{{ $t('paymentPlanButton') }}</span>
  </v-btn>
  <span @click="getPaymentPlanReportUrl" :disabled="loading" :loading="loading" v-else>
    {{ $t('paymentPlanButton') }}
  </span>
</template>

<script>
  import { apiResource } from '@/util/resources'
  export default {
    props: ['msnr'],
    data: function () {
      return {
        loading: false
      }
    },
    computed: {
      locale () {
        return this.$store.getters.longLocale
      }
    },
    methods: {
      getPaymentPlanReportUrl () {
        this.$matomo && this.$matomo.trackEvent("Information", "Download Report", "Print Payment Plan Information")
        this.loading = true
        apiResource({ method: 'get', url: '/api/paymentplan/paymentplanconfirmation/' + this.locale + '/' + this.msnr, responseType: 'arraybuffer' }).then((response) => {
          this.loading = false
          let blob = new Blob([response.data], { type: 'application/pdf' })
          // IE10+ : (has Blob, but not a[download] or URL)
          if (navigator.msSaveBlob) {
            return navigator.msSaveBlob(blob, this.$t('paymentPlanConfirmation') + '_' + this.msnr + '.pdf')
          } else {
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = this.$t('paymentPlanConfirmation') + '_' + this.msnr + '.pdf'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        }).catch((errorResponse) => {
          this.loading = false
          this.$store.commit('setMessage', { type: 'error', text: 'error.server.0', translate: true })
        })
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "paymentPlanButton": "Lataa maksusuunnitelma (pdf)",
  "paymentPlanConfirmation": "Maksusuunnitelmavahvistus"
  },
  "se": {
  "paymentPlanButton": "Ladda betalningsplan info (pdf)",
  "paymentPlanConfirmation": "Betalningsplansbekräftelse"
  },
  "en": {
  "paymentPlanButton": "Download payment plan information (pdf)",
  "paymentPlanConfirmation": "Paymentplanconfirmation"
  }
  }
</i18n>
